import main from "./helsinki_university_logo.svg"
import logo from "./helsingin-yliopisto.png"

const animalHospital = {
  main,
  logo,
}

export default animalHospital
